module.exports = "/_next/static/images/main-visual-menu-none-6cec3a396d3f6e4b5dd5721fa6ebf19a.jpg";